<div class="page-container d-flex flex-column min-vh-100">
    <app-header></app-header>
    <div class="flex-grow-1">
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</div>